/**
 * @file Muses class
 * @author liuye11(liuye11@baidu.com)
 */

import Ria from '@baidu/ve-ria';

export default class Muses extends Ria {

    /**
     * 构造器，等 ve-ria 升级之后，就不用 extends 了
     *
     * @constructor
     * @param {Object} config 配置
     * @param {Object} constants 常量
     * @param {*} AppComponent 渲染的app组件
     */
    constructor(config, constants, AppComponent) {
        super(config, constants, AppComponent);

        if (config) {
            this.config = config;
        }

        if (constants) {
            this.constants = constants;
        }

        if (AppComponent) {
            this.AppComponent = AppComponent;
        }
    }
}
